import bigCursorIcon from '../../icons/bigCursorIcon.svg'
import readingGuideIcon from '../../icons/readingGuideIcon.svg'
import { isMobileDevice } from '../../utils/isMobileDevice'

const buttons = [
  {
    label: 'Reading Guide',
    key: 'readable-guide',
    icon: readingGuideIcon,
  },
  {
    label: 'Big Cursor',
    key: 'big-cursor',
    icon: bigCursorIcon,
  },
]

export default isMobileDevice() ? buttons.filter((b) => b.key !== 'big-cursor') : buttons
